// extracted by mini-css-extract-plugin
export default {"referralComponent":"K-","greyBack":"L-","greenBack":"M-","greenText":"N-","explainText":"O-","spinner":"P-","storedText":"Q-"};
    if(module.hot) {
      // 1737143664248
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  